import { render, staticRenderFns } from "./EditionBadge.vue?vue&type=template&id=2137eba9&scoped=true&"
import script from "./EditionBadge.vue?vue&type=script&lang=js&"
export * from "./EditionBadge.vue?vue&type=script&lang=js&"
import style0 from "./EditionBadge.vue?vue&type=style&index=0&id=2137eba9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2137eba9",
  null
  
)

export default component.exports